<template>
  <div class="tmb-msi">
    <div class="tab-box">
      <van-tabs
        v-model="active"
        background="none"
        color="#4B84FF"
        line-width="20"
        title-active-color="#2F354D"
        title-inactive-color="#9095A7"
        @change="handleTabs"
      >
        <van-tab v-for="(item, index) in tab" :title="item" :key="index" />
      </van-tabs>
    </div>
    <div class="tmb" v-show="active == 0">
      <TMB :tmbData="tmbData" />
    </div>
    <div class="tmb" v-show="active == 1">
      <MSI :msiData="msiData" />
    </div>
  </div>
</template>
<script>
import TMB from "./components/tmbMsi/TMB.vue";
import MSI from "./components/tmbMsi/MSI.vue";
import { tmbDetails, msiDetails } from "@/api/reportQuery";
import { mapState } from "vuex";
export default {
  name: "tmb-msi",
  components: {
    TMB,
    MSI,
  },
  data() {
    return {
      active: 0,
      msiData: {},
      tmbData: {},
      tab: ["TMB","MSI"],
    };
  },
  created() {},
  computed: {
    ...mapState("embry", ["publicParams"]),
  },
  
  methods: {
    async getTmb(fname, fid) {
      try {
        console.log(tmbDetails);
        let { data } = await tmbDetails({
          labOriginalSampleNo: fname,
          productId: fid,
        });
        this.tmbData = {
          result: data.tmbValue,
          resultText: data.tmbSummary2,
          jxText: data.tmb,
          careful: "",
        };
      } catch (error) {}
    },
    async getMsi(fname, fid) {
      try {
        let { data } = await msiDetails({
          labOriginalSampleNo: fname,
          productId: fid,
        });
        console.log(data);
        this.msiData = {
          result: data.msiStatus,
          resultText: data.msiSummary2,
          jxText: data.msi,
          careful: "",
        };
      } catch (error) {}
    },
    handleTabs(val) {},
  },
  beforeRouteEnter(to, from, next) {
    console.log(to,from);
    window.NativeCallJS = (res) => {
      var par = JSON.parse(res);
      console.log(par, "进入页面之前获取");
      next((vm) => {
        console.log(par.tab, "0000");
        vm.active = Number(par.tabType)
        console.log(vm.active,2222222)
        par.tab.forEach((item) => {
          if (item == "TMB") {
            vm.getTmb(par.fname, par.fid);
          }
          if (item == "MSI") {
            vm.getMsi(par.fname, par.fid);
          }
        });
        vm.tab = par.tab;
      });
    };
  },
};
</script>
<style lang="less" scoped>
.tmb-msi {
  padding: 10 16px;
  .tmb {
    padding: 0 10px 20px;
  }
  /deep/.van-tabs--line .van-tabs__wrap {
    height: 30px;
  }
  /deep/.van-tab{
     font-size: 14PX;
  }
  // /deep/.van-tab--active .van-tab__text--ellipsis {
  //   // font-size: 14PX;
  //   // font-family: @family;
  //   // font-weight: 500;
  //   // color: #2f354d;
  // }
  .tab-box {
    height: 40px;
    margin-bottom: 10px;
    background: transparent;
    // box-sizing: border-box;
    // border-top-left-radius: 10px;
    // border-top-right-radius: 10px;
  }
}
</style>
